
import React from "react";
import { Button } from "@/components/ui/button";
import { Dices, ChevronRight, Save, RefreshCw } from "lucide-react";
import { JournalStage } from "@/hooks/useJournalFlow";

interface JournalFormActionsProps {
  currentStage: JournalStage;
  onContinue: () => void;
  onRollDice: () => void;
  hasDiceRolled?: boolean;
  onReRoll: () => void;
}

const JournalFormActions: React.FC<JournalFormActionsProps> = ({
  currentStage,
  onContinue,
  onRollDice,
  hasDiceRolled = false,
  onReRoll,
}) => {
  console.log("JournalFormActions render:", { currentStage, hasDiceRolled });
  
  const handleReRollClick = () => {
    console.log("JournalFormActions: Re-roll button clicked");
    onReRoll();
  };
  
  return (
    <div className="flex space-x-2">
      {/* FIXED: Show Roll Dice button only when stuck and not rolled yet */}
      {currentStage === "stuck" && !hasDiceRolled && (
        <Button 
          type="button" 
          onClick={onRollDice}
          variant="outline"
          className="flex items-center gap-2"
          data-tutorial="roll-dice-button"
        >
          <Dices className="h-4 w-4" />
          Roll Dice
        </Button>
      )}
      
      {/* FIXED: Show Continue button for perception and intention stages */}
      {hasDiceRolled && (currentStage === "perception" || currentStage === "intention") && (
        <Button 
          type="button" 
          onClick={onContinue}
          variant="default"
          className="flex items-center gap-2"
          data-tutorial="continue-button"
        >
          Continue <ChevronRight className="h-4 w-4" />
        </Button>
      )}
      
      {/* Show Re-Roll button when dice has been rolled and we're past stuck stage */}
      {hasDiceRolled && currentStage !== "stuck" && (
        <Button 
          type="button" 
          onClick={handleReRollClick}
          variant="outline"
          className="flex items-center gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Re-Roll Dice
        </Button>
      )}
      
      {/* Always show Save button */}
      <Button 
        type="submit" 
        variant={currentStage === "completed" || currentStage === "nextStep" ? "default" : "outline"}
        className="flex items-center gap-2"
        data-tutorial="save-button"
      >
        <Save className="h-4 w-4" />
        Save Entry
      </Button>
    </div>
  );
};

export default JournalFormActions;
